/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import cn from 'classnames'

import PeripheralBridge from '../utils/peripheralBridge'
import { isOfflineApproval } from '../utils/offlineReplayStatuses'
import { SIGNATURE_THRESHOLD_AMOUNT } from '../constants'
import { centsToDollars } from '../utils/formatters'

import styles from './CardReaderModal.module.scss'

import { fakeCreditCardResponse, showFakeCreditCard } from '../utils/fakeCreditCardResponse'

const Ready = ({ onCancel, onFakeCreditCardSwipe }) => {
  return (
    <>
      <p className={styles.readyText}>Ready</p>

      { showFakeCreditCard() && (
        <button
          text="fake credit card"
          onClick={onFakeCreditCardSwipe}
          className={styles.cancelButton}
        >Pretend Credit Card was swiped</button>
      )}

      <button
        text="cancel"
        onClick={onCancel}
        className={styles.cancelButton}
      >cancel</button>
    </>
  )
}

const Error = ({ onRetry, onCancel }) => {
  return (
    <>
      <p className={styles.paymentFailedText}>Payment Failed</p>
      <button
        onClick={onRetry}
        className={styles.retryButton}
        >retry</button>
      <button
        onClick={onCancel}
        className={styles.cancelButton}
        >cancel</button>
    </>
  )
}

const CardReaderModal = ({ history, total, onSuccess, onOfflineSuccess, onClose, className }) => {
  const generateUuid = require('uuid/v4')
  const [uuid] = useState(generateUuid())
  const [formattedTotal] = useState(centsToDollars(total || 0))
  const [status, setStatus] = useState('ready')
  const classNames = cn(styles.cardReaderModal, className)

  const onCancel = () => {
    const bridgeInstance = PeripheralBridge.getBridge()
    if (!bridgeInstance) {
      onClose()
    } else {
      bridgeInstance.call('cancelTransactionAttempt')
      onClose()
    }
  }

  const onFakeCreditCardSwipe = () => {
    onSuccess(fakeCreditCardResponse(uuid, formattedTotal))
    redirectToNextStep()
  }

  const onRetry = () => {
    const bridgeInstance = PeripheralBridge.getBridge()

    if (!bridgeInstance) {
      setStatus('ready')
    } else {
      setStatus('ready')
      bridgeInstance.call('executeSaleRequest', { 'uuid': uuid, 'amount': formattedTotal })
    }
  }

  const redirectToNextStep = () => {
    const newRoute = (SIGNATURE_THRESHOLD_AMOUNT === 0 || (SIGNATURE_THRESHOLD_AMOUNT && total >= SIGNATURE_THRESHOLD_AMOUNT)) ? `/signature/${uuid}` : `/receipt/${uuid}`
    history.push(newRoute)
  }

  let content = <Ready onCancel={onCancel} onFakeCreditCardSwipe={onFakeCreditCardSwipe} />

  if (status === 'error') {
    content = <Error onCancel={onCancel} onRetry={onRetry} />
  }

  useEffect(() => {
    const bridgeInstance = PeripheralBridge.getBridge()
    if (!bridgeInstance) return

    bridgeInstance.registerHandler('handleResult', function(data, callback) {
      if (data.status === 'ACCEPT') {
        const dataWithUuid = { ...data, uuid }

        isOfflineApproval(data) ? onOfflineSuccess(dataWithUuid) : onSuccess(dataWithUuid)

        redirectToNextStep()
      } else {
        setStatus('error')
      }

      var response = { 'message': data }
      callback(response)
    })

    bridgeInstance.call('executeSaleRequest', { 'uuid': uuid, 'amount': formattedTotal })
  }, [total])

  return (
    <div className={classNames}>
      <div className={styles.overlay}></div>
      <div className={styles.content}>
        <div className={styles.header}>
          <h1>Card Reader Status</h1>
        </div>
        <div className={styles.body}>
          {content}
        </div>
      </div>
    </div>
  )
}

CardReaderModal.defaultProps = {
  total: 0,
  onClose: () => {},
  onSuccess: () => {},
  onOfflineSuccess: () => {},
}

CardReaderModal.propTypes = {
  total: PropTypes.number,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  onOfflineSuccess: PropTypes.func,
}

export default withRouter(CardReaderModal)
